import { createContext, useContext } from "react";

/** True inside the embed / public viewer: the viewer token reads only, so write and data-drill controls show disabled. */
const ViewerModeContext = createContext<boolean>(false);
export const ViewerModeProvider = ViewerModeContext.Provider;
export const useIsViewerMode = (): boolean => useContext(ViewerModeContext);
